import { PropsWithChildren } from 'react'
import AccessDenied from '../../../components/AccessDenied'
import { useHasGlobalModulesAccess } from '../permissions/usePermissions'

export default function GlobalModulesAccessGuard({
  children,
}: PropsWithChildren) {
  const hasGlobalModulesAccess = useHasGlobalModulesAccess()

  if (!hasGlobalModulesAccess) {
    return <AccessDenied />
  }

  return <>{children}</>
}
